// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vR-z","inlineTitle":"wR-z","sponsoredAdsWrapper":"xR-z","marketplaceRecosWrapper":"yR-z"};